import React from 'react';

const shimmer: React.CSSProperties = {
  background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
  backgroundSize: '200% 100%',
  animation: 'shimmer 2s infinite',
};

const FeeHistorySkeletonLoader: React.FC = () => {
  return (
    <>
      <div
        style={{
          background: 'white',
          borderRadius: 20,
          boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
          border: '1px solid #e5e7eb',
          overflow: 'hidden',
          width: '100%',
        }}
      >
        {/* Table header bar */}
        <div
          style={{
            padding: '16px 20px',
            borderBottom: '1px solid #f3f4f6',
            background: 'linear-gradient(135deg,#fafbfc 0%,#f8fafc 100%)',
            display: 'flex',
            gap: 16,
            alignItems: 'center',
          }}
        >
          {[140, 100, 70, 90, 90, 80, 90, 70, 60].map((w, i) => (
            <div
              key={i}
              style={{
                width: w,
                height: 12,
                borderRadius: 6,
                flexShrink: 0,
                ...shimmer,
              }}
            />
          ))}
        </div>

        {/* Rows — Student · Class · Month · Receipt · Paid Date · Amount · Status · Pay Mode · Actions */}
        <div style={{ padding: '8px 0' }}>
          {[...Array(10)].map((_, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 16,
                padding: '16px 20px',
                borderBottom: index < 9 ? '1px solid #f3f4f6' : 'none',
                animation: 'pulse 1.5s ease-in-out infinite',
                animationDelay: `${index * 0.1}s`,
              }}
            >
              {/* Student (avatar + name + meta) */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, flex: 1.4, minWidth: 0 }}>
                <div style={{ width: 38, height: 38, borderRadius: 10, flexShrink: 0, ...shimmer }} />
                <div style={{ minWidth: 0, flex: 1 }}>
                  <div style={{ width: '75%', height: 14, borderRadius: 8, marginBottom: 6, ...shimmer }} />
                  <div style={{ width: '55%', height: 11, borderRadius: 8, ...shimmer }} />
                </div>
              </div>

              {/* Class & Section */}
              <div style={{ width: 100, flexShrink: 0 }}>
                <div style={{ width: '85%', height: 13, borderRadius: 8, marginBottom: 6, ...shimmer }} />
                <div style={{ width: '50%', height: 11, borderRadius: 8, ...shimmer }} />
              </div>

              {/* Month */}
              <div style={{ width: 80, height: 14, borderRadius: 8, flexShrink: 0, ...shimmer }} />

              {/* Receipt No */}
              <div style={{ width: 100, height: 14, borderRadius: 8, flexShrink: 0, ...shimmer }} />

              {/* Paid Date */}
              <div style={{ width: 100, height: 14, borderRadius: 8, flexShrink: 0, ...shimmer }} />

              {/* Amount */}
              <div style={{ width: 90, flexShrink: 0 }}>
                <div style={{ width: '90%', height: 14, borderRadius: 8, marginBottom: 4, ...shimmer }} />
                <div style={{ width: '50%', height: 10, borderRadius: 8, ...shimmer }} />
              </div>

              {/* Status pill */}
              <div style={{ width: 90, height: 26, borderRadius: 20, flexShrink: 0, ...shimmer }} />

              {/* Pay Mode */}
              <div style={{ width: 80, height: 14, borderRadius: 8, flexShrink: 0, ...shimmer }} />

              {/* Actions */}
              <div style={{ display: 'flex', justifyContent: 'center', flexShrink: 0, width: 48 }}>
                <div style={{ width: 32, height: 32, borderRadius: 8, ...shimmer }} />
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div
          style={{
            background: '#fafbfc',
            borderTop: '1px solid #e5e7eb',
            padding: '20px 16px',
            display: 'flex',
            justifyContent: 'center',
            gap: 8,
          }}
        >
          {[...Array(7)].map((_, i) => (
            <div
              key={i}
              style={{
                width: 36,
                height: 36,
                borderRadius: 8,
                ...shimmer,
              }}
            />
          ))}
        </div>
      </div>

      <style>{`
        @keyframes shimmer {
          0% { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>
    </>
  );
};

export default FeeHistorySkeletonLoader;